
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { Loader2, RefreshCw } from 'lucide-react';

interface AdviceDisplayProps {
  advice: string;
  isLoading: boolean;
  hasError: boolean;
  retryFetch: () => void;
  selectedInterests: string[];
}

export const AdviceDisplay: React.FC<AdviceDisplayProps> = ({
  advice,
  isLoading,
  hasError,
  retryFetch,
  selectedInterests
}) => {
  if (isLoading) {
    return (
      <div className="space-y-3">
        <div className="flex items-center justify-center py-4">
          <Loader2 className="h-8 w-8 text-hormony-coral animate-spin" />
        </div>
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-full" />
      </div>
    );
  }
  
  if (hasError) {
    return (
      <div className="text-center py-4">
        <p className="text-muted-foreground mb-4">
          We couldn't generate advice at the moment. Please try again.
        </p>
        <Button onClick={retryFetch} variant="outline">
          Retry
        </Button>
      </div>
    );
  }
  
  return (
    <div className="prose prose-sm max-w-none">
      <div 
        className="whitespace-pre-line" 
        dangerouslySetInnerHTML={{ __html: advice.replace(/\n/g, '<br />') }} 
      />
    </div>
  );
};
